import { render, staticRenderFns } from "./NewPublishersCountPerDurationCard.vue?vue&type=template&id=0332d3ca&"
import script from "./NewPublishersCountPerDurationCard.vue?vue&type=script&lang=js&"
export * from "./NewPublishersCountPerDurationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports